import React from 'react';
import * as yup from 'yup';
import SelectWithValidate from '../input/select-with-validate';
import { useStringsContext } from '../../../contexts/strings';
import { Segment } from '../../../types/segment';
import { PushNotificationTarget } from '../../../types/notification';

type Props = {
  value: string;
  name: string;
  segments: Segment[];
  label: string;
  onValue: (key: string, value: string, segments: Segment[]) => void;
  onValidation: (key: string, isValid: boolean) => void;
  isNews?: boolean;
  topicContentType?: Segment['contentType'];
  hideValidationError: boolean;
};

export const getTargetId = (target?: PushNotificationTarget) => {
  if (target?.type === 'ALL') {
    return 'ALL';
  }

  return target?.value || '';
};
export const getSelectedTarget = (
  segments: Segment[],
  targetId: string
): PushNotificationTarget => {
  if (targetId === 'ALL') {
    return {
      type: 'ALL',
      value: '',
    };
  }

  const selectedSegment = segments.find((segment) => segment.id === targetId);
  if (selectedSegment) {
    return {
      type: selectedSegment.type,
      value: selectedSegment.id,
    };
  }
  return {
    type: 'ALL',
    value: '',
  };
};
export default function SegmentTargetSelect(props: Props) {
  const {
    name,
    value,
    segments,
    label,
    onValue,
    onValidation,
    isNews,
    topicContentType,
    hideValidationError,
  } = props;
  const { strings } = useStringsContext();
  const allTopicContentType = topicContentType || (isNews ? 'NEWS' : undefined);

  const { allValue, allText } = (() => {
    if (allTopicContentType) {
      const allTopic = segments.find(
        (segment) => segment.type === 'TOPIC' && segment.contentType === allTopicContentType
      );
      if (allTopic) {
        return {
          allValue: allTopic.id,
          allText: `${strings.pushNotifications.allOption} - ${allTopic.name} (${strings.pushNotifications.topic})`,
        };
      }
    }
    return {
      allValue: 'ALL',
      allText: strings.pushNotifications.allOption,
    };
  })();

  const validSegments = segments.filter(
    (segment) => segment.id !== allValue && (allTopicContentType ? segment.type !== 'TOPIC' : true)
  );

  return (
    <SelectWithValidate
      value={value}
      name={name}
      label={label}
      onValue={(key, value) => {
        onValue(key, value, segments);
      }}
      onValidation={(key, isValid) => {
        onValidation(key, isValid);
      }}
      options={[
        allValue,
        ...validSegments.map((segment) => {
          return segment.id;
        }),
      ]}
      optionsText={[
        allText,
        ...validSegments.map((segment) => {
          return `${segment.name}${segment.type === 'TOPIC' ? ` (${strings.pushNotifications.topic})` : ''}`;
        }),
      ]}
      validation={yup.string().required(strings.validations.isRequired)}
      hideValidationError={hideValidationError}
      fullWidth
    />
  );
}
